import '@vfde-brix/icon/dist/styles.css';
import '@vfde-brix/system-icon/dist/styles.css';
import '@vfde-brix/icon-text/dist/styles.css';
import { createIconTextComponent } from '@vfde-brix/icon-text';
import { NO_PATTERN_BUSINESS_LOGIC } from '@vfde-brix/core';
import { createComponents } from '../../utils/initComponents';

createComponents('brix-icon-text', createIconTextComponent, NO_PATTERN_BUSINESS_LOGIC);
